import {
  Avatar,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
  Typography,
} from '@mui/material';
import { PropsWithChildren } from 'react';

const ResultAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(6),
  height: theme.spacing(6),
  fontSize: theme.fontSizes.sm,
  fontWeight: theme.typography.fontWeightMedium,
  lineHeight: '100%',
}));

const Result = styled(ListItemButton)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.xs),
}));

const ResultIcon = styled(ListItemIcon)({
  minWidth: 24,
  width: 24,
});

type Props = {
  id: string;
  name: string;
  logo: string;
  onClick: (id: string) => void;
};
const SearchResultItem: React.FC<PropsWithChildren<Props>> = ({
  id,
  name,
  logo,
  onClick,
  children,
}) => {
  return (
    <Result
      onClick={() => {
        onClick(id);
      }}
    >
      <ResultIcon>
        <ResultAvatar variant="circular" src={logo}>
          {name.charAt(0)}
        </ResultAvatar>
      </ResultIcon>
      <ListItemText>
        <Typography variant="h6">{name}</Typography>
      </ListItemText>
      {children}
    </Result>
  );
};

export default SearchResultItem;
